import {useCustomerContext} from 'components/providers';
import {useRouter} from 'next/router';
import {useCallback} from 'react';
import useCookie, {getCookie} from 'react-use-cookie';
import {StorageKeyEnum} from 'types';
import {authUtil} from 'utils/auth';

interface RedirectToLoginParams {
  redirectTo?: string;
}

export const useAuth = () => {
  const {push} = useRouter();
  const [accessToken, setAccessToken] = useCookie(StorageKeyEnum.ACCESS_TOKEN, getCookie(StorageKeyEnum.ACCESS_TOKEN));
  const {customer} = useCustomerContext();

  const redirectToLoginPage = useCallback(
    (params?: RedirectToLoginParams) => {
      let path = '/login';

      if (params?.redirectTo) {
        path += `?redirectTo=${params.redirectTo}`;
      }
      push(path);
    },
    [push],
  );

  const nonAuthRedirectTo = useCallback(
    (params?: RedirectToLoginParams) => {
      if (!accessToken) {
        redirectToLoginPage(params);
      }
    },
    [redirectToLoginPage, accessToken],
  );

  const logout = () => {
    authUtil.logout();
    push('/');
  };

  return {
    isAuthenticated: !!accessToken || customer?.phonenumber ? true : false,
    redirectToLoginPage,
    nonAuthRedirectTo,
    logout,
    isLoading: false,
    setAccessToken,
  };
};
